import { render, staticRenderFns } from "./doctorInfoTpl.vue?vue&type=template&id=bc81212a&"
import script from "./doctorInfoTpl.vue?vue&type=script&lang=js&"
export * from "./doctorInfoTpl.vue?vue&type=script&lang=js&"
import style0 from "./doctorInfoTpl.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports